<div class="container">
  <div class="d-flex justify-content-end mb-2">
    <div class="btn-group">
      <button class=" btn btn-primary" (click)="decDay()">
        <sb-icon class="icon-in-btn" icon="chevronLeft"></sb-icon>
      </button>
      <button class="btn btn-primary" (click)="incDay()">
        <sb-icon class="icon-in-btn" icon="chevronRight"></sb-icon>
      </button>
    </div>
  </div>
  <ng-scrollbar class="scrollwrapper">
    <div class="d-flex flex-row hourline cursor-pointer" [ngClass]="getClasses(hour)" *ngFor="let hour of hours">
      {{formatHour(hour)}}
    </div>
  </ng-scrollbar>
</div>
